import { loadSearches } from '@/utils/spec/searchHistory'
import { loadSpec } from '@/utils/spec/specStorage'

/**
 * ЕСТЬ ЛИ В ЭТОМ БРАУЗЕРЕ КАБИНЕТ. Входа по паролю нет, и кабинет — это записи localStorage, поэтому
 * «зарегистрирован» читается по ним.
 *
 * Главный признак — почта в спеке: её пишут ровно те три шага, где человек себя назвал, — регистрация
 * воронки 4 (SignUpStore), контакт онбординга воронок 1–3 (onboardSpec) и возврат с оплаты с почтой
 * (purchase.ts). Первые два — это и есть Lead, поэтому «почта есть» значит «Lead в этом браузере был».
 *
 * Второй признак — хоть один записанный поиск. Он нужен одному человеку: тому, кто заплатил и вернулся
 * с оплаты в ДРУГОЙ браузер без почты в адресе (in-app браузер FB против Safari) — покупка записана,
 * почты нет, и без этого признака воронка 4 отправила бы плательщика регистрироваться заново.
 * Lead-а такой человек уже не обходит: он пришёл после денег.
 *
 * Выход из кабинета (HomeStore.signOut) стирает и то и другое — после него кабинета здесь нет.
 */
export const hasWorkspaceHere = (): boolean => Boolean(loadSpec().contactEmail) || loadSearches().length > 0
